import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { MyfireService } from "../../service/myfire.service";
import { UserService } from "../../service/user.service";
import * as firebase from "firebase";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  error: any;
  constructor(
    private myfire: MyfireService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {}
  onSubmit(form: NgForm) {
    const email = form.value.email;
    const password = form.value.password;

    firebase
      .auth() //da se uloguje ako vec postoji
      .signInWithEmailAndPassword(email, password)
      .then(userData => {
        if (userData) {
          return this.myfire.getUserFromDataBase(userData.uid); //da se tacni user odredi u bazi podataka i spoji sa gore authentikacijom
        } else {
          firebase.auth().signOut();
        }
      })
      .then(userData => {
        if (userData) {
          this.userService.set(userData);
          // this.router.navigate(["/allposts"]);
        }
      })
      .catch(() => {
        this.error = new Error(
          "Email adreasa ili password nisu dobro ukcani!"
        ).message;
      });
  }
}
